import basicController from "servicestack/basic.controller.properties";
import templateUrl from "emun.swatch/swatches.htm";
import AutoQuery from "servicestack/auto-query/auto-query";
import Config from "emun.swatch/swatch.config";
import 'emun.swatch/swatches.client.scss';

export class SwatchesController {
  constructor() {
    let $ctrl = this;
    basicController($ctrl);
    
    $ctrl.query = new AutoQuery(Config.autoQueryOptions);
    $ctrl.bus = $ctrl.query.bus;
    $ctrl.selectAll = false;
  }
  viewSwatch(id) {
    this.$state.go("swatch.view", { swatchId: id, mode: this.mode });
  }
  load() {
    return this.query.load();
  }
  getImageUrl(id, size) {
    return this.$appConfig.productImage(id, size);
  }
}

export default {
  bindings: {
    mode: "@"
  },
  controller: SwatchesController,
  templateUrl($element, $attrs) {
    return $attrs.templateUrl || templateUrl;
  }
};
